interface MetricCardProps {
  title: string
  value?: number
  isLoading?: boolean
  className?: string
}

export function MetricCard({ title, value, isLoading, className = '' }: MetricCardProps) {
  return (
    <div className={`bg-card rounded-lg border border-border p-6 ${className}`}>
      <p className="text-sm text-muted-foreground">{title}</p>
      {isLoading ? (
        <div className="h-8 w-24 bg-secondary animate-pulse rounded mt-1" />
      ) : (
        <p className="text-3xl font-bold text-foreground mt-1">
          {value?.toLocaleString() ?? '-'}
        </p>
      )}
    </div>
  )
}
